import { api } from './api';
import { ActivationMetrics, ActivationEventType } from '../types/mode.types';

interface TrackEventRequest {
  eventType: ActivationEventType;
  sessionId?: string;
  metadata?: Record<string, any>;
}

export const activationService = {
  /**
   * Track an activation event
   */
  async trackEvent(siteId: number, request: TrackEventRequest): Promise<void> {
    await api.post(`/coreapi/sites/${siteId}/activation/events`, request);
  },

  /**
   * Get activation metrics for a site
   */
  async getMetrics(siteId: number): Promise<ActivationMetrics> {
    const response = await api.get<ActivationMetrics>(`/coreapi/sites/${siteId}/activation/metrics`);
    return response.data;
  }
};
